import { Grid, Typography } from "@mui/material"
import OneInput from "../../../../../Components/OneInput/OneInput"

export const LabelInput = ({
    name, type, labelWidth, inputWidth, componentXs, componentXl, componentHeight, labelText, inputValue,
    inputChange, typographySx, disabled = false, EndBtn = false, maxLength = false
}) => {
    return (
        <Grid xs={componentXs || true} xl={componentXl || true} sx={{ height: componentHeight, display: 'flex', flexDirection: 'row' }}>
            <div style={{ width: labelWidth }}>
                <Typography sx={typographySx}>
                    {labelText}
                </Typography>
            </div>
            <div style={{ width: inputWidth }}>
                <OneInput
                    name={name}
                    type={type}
                    value={inputValue}
                    onChange={inputChange}
                    disabled={disabled}
                    maxLength={maxLength}
                />
            </div>
            {EndBtn &&
                <div style={{ paddingLeft: '5px' }}>
                    <EndBtn />
                </div>
            }
        </Grid>
    )
}
